import React from "react";

import { deeplinkTranslator } from "modules/App/deeplinkTranslator";
import Link from "components/link";
import { ChipsWithImage } from "modules/DesignSystem/components/Chips";
import { ItemSetsScreenSection } from "resources/AudiotekaApi";

import css from "./item-sets.module.scss";

interface ItemSetsProps {
  sets: ItemSetsScreenSection["elements"];
}

function ItemSets({ sets }: ItemSetsProps) {
  return (
    <ul className={css.list}>
      {sets.map((set) => (
        <li className={css.item} key={set.tracking_id}>
          <ChipsWithImage
            as={Link}
            title={set.label}
            label={set.accessibility_label}
            image={`${set.banner_url}?h=120`}
            {...deeplinkTranslator(set.deeplink, set.slug)}
          />
        </li>
      ))}
    </ul>
  );
}

export default ItemSets;
